import { FullScreenHandle } from "react-full-screen";
import { Button } from "@heroui/react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { App, Integration } from "/app/src/models";
import { useCallback, useContext } from "react";
import NavigationMenuContext from "/app/src/contexts/NavigationMenuContext";
/**
 * Renders the controls component.
 *
 * @param {Object} props - The properties object.
 * @param {Integration} props.integration - The integration instance.
 * @param {App} props.app - The application instance.
 * @param {boolean} props.buttonVisible - Indicates if the control button is visible.
 * @param {FullScreenHandle} props.handler - Handles fullscreen operations.
 *
 * @returns {JSX.Element} The rendered controls component.
 */
export default function Controls({
  integration,
  app,
  buttonVisible,
  handler,
}: {
  integration: Integration;
  app: App;
  buttonVisible: boolean;
  handler: FullScreenHandle;
}) {
  const navigationMenu = useContext(NavigationMenuContext);

  /**
   * Exits the fullscreen mode.
   *
   * @returns {void}
   */
  const handleExitFullscreen = useCallback((): void => {
    handler.exit();
  }, [handler]);

  /**
   * Enters the fullscreen mode.
   *
   * @returns {void}
   */
  const handleEnterFullscreen = useCallback((): void => {
    handler.enter();
  }, [handler]);

  const { t } = useTranslation();
  return (
    <div
      className={`controls mt-0 ${navigationMenu === "1" ? " -mx-[16px] mb-[25px]" : "-mx-[25px] mb-[25px]"}`}
    >
      <div className="icon"> </div>

      {integration && (
        <div className="title">
          {app && <Link to={`/apps/${app.id}`}>{app.name}</Link>}
          <span className="separator">{">"}</span>
          <h1>{integration.name}</h1>
        </div>
      )}
      {buttonVisible && (
        <div className="controlButtons">
          {!handler.active ? (
            <Button
              color="default"
              radius="none"
              variant="bordered"
              size="sm"
              onPress={handleEnterFullscreen}
              className="hover:text-primary-default hover:border-primary-default"
            >
              {t("translation:enter_fullscreen")}
            </Button>
          ) : (
            <Button
              color="default"
              radius="none"
              variant="bordered"
              size="sm"
              onPress={handleExitFullscreen}
              className="hover:text-primary-default hover:border-primary-default"
            >
              {t("translation:exit_fullscreen")}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
